<template>
  <div id='titleCard' class='bg-dark text-white bigCard'>
    <span class='row'>
      <div id='title' class='text-center'>
        
        <img src = '/static/imgs/EJ_Title4.png' class = 'animated fadeIn sloDown'/>

        <!-- <h1 class='animated fadeIn sloDown' style=''>
          <strong>ERIK JACKSON</strong>
        </h1> -->

        <hr class='mx-5 animated fadeIn sloDown' style='border-color: #ff6b6b;'>

        <h4 class='animated fadeIn sloDown colorTransition'>
          <em style=''>Innovative Web Design</em>
        </h4>

        <p id = 'summary' class='mx-auto animated fadeIn sloDown'>
          My name is Erik Jackson and I'm a Web Developer and Designer based out of the Saint Paul, Minnesota.
          I make websites and apps that solve problems with JavaScript, React and Vue.
        </p>
        
        <br>

        <div id = 'navBtns' class = 'animated fadeIn sloDown'>

            <button 
              class='btn btn-lg btn-outline-secondary animated fadeIn mx-2' 
              v-on:click="delay('#/profile')"
              >Profile
            </button>
            
            <button 
              class='btn btn-lg btn-outline-secondary animated fadeIn mx-2' 
              v-on:click="delay('#/portfolio')"
              >Portfolio
            </button>
            
            <button 
              class='btn btn-lg btn-outline-secondary animated fadeIn mx-2' 
              v-on:click="delay('#/contact')"
              >Contact
            </button>       
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import store from '../globals'
import $ from 'jquery'
export default {
  name: 'HelloWorld',
  data () {
    return {
      pastTitle: store.state.pastTitle
    }
  },
  mounted () {
    store.commit('noMenu')
  },
  methods: {
    delay (URL) {
      console.log(URL)
      $('.animated .fadeIn').removeClass('animated fadeIn sloDown')
      $('#titleCard').addClass('animated fadeOut')

      setTimeout(function () {
        store.commit('menu')
        console.log(store.state.pastTitle)
        window.location = URL
      }, 1000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1:hover, h2:hover {
  color: #ff6b6b;
}

h4 {
  color: #ff6b6b
}

.sloDown{
    -webkit-animation-duration: 5s;
    -moz-animation-duration: 5;
    -ms-transition-animation-duration: 5s;
}

@media screen and (max-width: 768px) {
  button {
    margin-bottom: 10px;
  }
  p {
    padding-left: 5%;
    padding-right: 5%;
  }

  img {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 5%;
    padding-right: 5%;
  }

  #navBtns {
    display: inline-grid;
  }
  
  #summary {
    width: 100%;
    margin-right: 0px; 
    margin-left: 0px;
  }

  #title {
    position: absolute;
    top: 20%;
    width: 90%;
    left: 5%;
    /* min-height: 650px; */
  }

  #titleCard {
    min-height: 650px;
    width: 100%;
    margin-top: 0px;
    margin-left: 0px;
    margin-right:0px
  }
} 

@media screen and (min-width: 768px) {
  p {
    padding-left: 20%;
    padding-right: 20%;
  }

  img {
    width: 80%;
  }

  #title {
    position: absolute;
    left: 5%;
    top: 15%;
    width: 90%
  }

  #titleCard {
    min-height:650px;
    width: 90%;
    margin-right: 5%;
    margin-left: 5%;
    margin-top: 5%
  }
}
@media screen and (min-width: 992px){

  h1 {
    font-size:50px
  }


  img {
    width: 60%;
    height: auto;
  }

  #title{
      position: absolute;
      display: inline;
      width: 80%;
      left: 10%;
      top: 30%;
  }

  #titleCard {
    width: 80%;
    margin-top: 60px;
    margin-left: 10%;
    margin-right: 10%;
    min-height: 650px;

  }
}

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue